import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyConversationalHistory = lazyWithRetry(
  () => import("./ConversationalHistory"),
);

const ConversationalHistory = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyConversationalHistory {...props} />;

export default ConversationalHistory;
